import { useElementBounding as F } from "@vueuse/core";
import { defineComponent as H, ref as z, useSlots as A, computed as r, openBlock as n, createElementBlock as l, normalizeClass as o, Fragment as O, renderSlot as c, createElementVNode as t, createTextVNode as x, toDisplayString as R, createCommentVNode as y } from "vue";
import { useResponsive as j } from "@onereach/ui-components-common/hooks";
import { _ as I } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
var s = /* @__PURE__ */ ((e) => (e.Auto = "auto", e.Primary = "primary", e.Success = "success", e.Warning = "warning", e.Error = "error", e))(s || {}), a = /* @__PURE__ */ ((e) => (e.Linear = "linear", e.Circle = "circle", e))(a || {});
const G = [
  // Typography
  "typography-caption-regular",
  // Theme
  "text-outline",
  "dark:text-outline-dark"
], J = {
  [a.Linear]: [
    // Layout
    "flex",
    "flex-col",
    // Box
    "w-full",
    "min-w-[160px]",
    "max-w-[295px]"
  ],
  [a.Circle]: [
    "-rotate-90"
  ]
}, K = [
  // Layout
  "flex",
  "flex-row",
  // Spacing
  "mb-[6px]"
], Q = [
  // Typography
  "typography-caption-bold",
  // Theme
  "text-on-background",
  "dark:text-on-background-dark"
], U = [
  // Spacing
  "ml-auto"
], X = [
  // Theme
  "stroke-surface-variant",
  "dark:stroke-surface-variant-dark"
], Y = [
  // Position
  "origin-center",
  // Animation
  "transition-[stroke-dashoffset]"
], Z = {
  [a.Linear]: [
    // Animation
    "animate-linear-loader"
  ],
  [a.Circle]: [
    // Animation
    "animate-circular-loader"
  ]
}, _ = {
  [s.Primary]: [
    // Theme
    "stroke-primary-hover",
    "dark:stroke-primary-hover-dark"
  ],
  [s.Success]: [
    // Theme
    "stroke-success-hover",
    "dark:stroke-success-hover-dark"
  ],
  [s.Warning]: [
    // Theme
    "stroke-warning-hover",
    "dark:stroke-warning-hover-dark"
  ],
  [s.Error]: [
    // Theme
    "stroke-error-hover",
    "dark:stroke-error-hover-dark"
  ]
}, ee = [
  // Spacing
  "mt-[2px]"
], re = H({
  name: "OrProgress",
  props: {
    maxValue: {
      type: Number,
      required: !1,
      default: 1
    },
    value: {
      type: Number,
      required: !1,
      default: null
    },
    progress: {
      type: Number,
      required: !1,
      default: null
    },
    precision: {
      type: Number,
      required: !1,
      default: 2
    },
    type: {
      type: String,
      required: !1,
      default: () => a.Linear
    },
    color: {
      type: String,
      required: !1,
      default: () => s.Auto
    },
    loading: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  expose: [
    "root"
  ],
  setup(e) {
    const u = z(), {
      header: f,
      label: h,
      percent: k,
      footer: g
    } = A(), { width: d } = F(u), i = r(() => e.progress ?? (e.value ?? 0) / (e.maxValue ?? 1)), B = r(() => e.value ?? (e.progress ?? 0) * (e.maxValue ?? 1)), w = r(() => Number((i.value * 100).toFixed(e.precision)) + "%"), m = r(() => e.type === a.Linear), p = r(() => e.type === a.Circle), b = r(() => !!f || !!h || !!k), P = r(() => !!g), v = r(() => e.loading ? s.Primary : e.color === s.Auto ? i.value <= 0.5 ? s.Success : i.value <= 0.95 ? s.Warning : s.Error : Object.values(s).includes(e.color) ? e.color : s.Success), L = r(() => W.value ? 20 : 16), N = r(() => [
      "or-progress-v3",
      ...G,
      ...J[e.type]
    ]), V = r(() => [
      ...K
    ]), $ = r(() => [
      ...Q
    ]), q = r(() => [
      ...U
    ]), C = r(() => [
      ...ee
    ]), D = r(() => [
      ...X
    ]), E = r(() => [
      ...Y,
      ...e.loading ? Z[e.type] : [],
      ..._[v.value]
    ]), S = r(
      () => m.value ? d.value - 4 : (
        // 2 + 2 px horizontal padding for rounding
        p.value ? 14 * Math.PI : (
          // 14 = diameter = viewBox - stroke-width
          0
        )
      )
    ), M = r(() => d.value ? d.value - 2 : "100%"), T = r(
      () => e.loading ? void 0 : (1 - i.value) * S.value
    ), { isMobile: W } = j();
    return {
      root: u,
      rootStyles: N,
      headerStyles: V,
      labelStyles: $,
      percentStyles: q,
      footerStyles: C,
      progressBarBackgroundStyles: D,
      progressBarMainPartStyles: E,
      strokeDasharray: S,
      strokeDashoffset: T,
      strokeWidth: M,
      localProgress: i,
      localValue: B,
      percent: w,
      isLinearType: m,
      isCircleType: p,
      isShowingHeader: b,
      isShowingFooter: P,
      localColor: v,
      computedSize: L
    };
  }
}), se = {
  width: "100%",
  height: "2"
}, oe = {
  fill: "none",
  "stroke-width": "2",
  "stroke-linecap": "round"
}, te = ["x2"], ae = ["x2", "stroke-dasharray", "stroke-dashoffset"], ne = ["width", "height"], le = {
  fill: "none",
  "stroke-width": "2",
  "stroke-linecap": "round"
}, ie = ["stroke-dasharray", "stroke-dashoffset"];
function ce(e, u, f, h, k, g) {
  return n(), l("div", {
    ref: "root",
    class: o(e.rootStyles)
  }, [
    e.isLinearType ? (n(), l(O, { key: 0 }, [
      e.isShowingHeader ? (n(), l("div", {
        key: 0,
        class: o(e.headerStyles)
      }, [
        c(e.$slots, "header", {}, () => [
          t("div", {
            class: o(e.labelStyles)
          }, [
            c(e.$slots, "label")
          ], 2),
          t("div", {
            class: o(e.percentStyles)
          }, [
            c(e.$slots, "percent", { value: e.percent }, () => [
              x(R(e.percent), 1)
            ])
          ], 2)
        ])
      ], 2)) : y("", !0),
      (n(), l("svg", se, [
        t("g", oe, [
          t("line", {
            class: o(e.progressBarBackgroundStyles),
            x1: "2",
            y1: "50%",
            x2: e.strokeWidth,
            y2: "50%"
          }, null, 10, te),
          t("line", {
            class: o(e.progressBarMainPartStyles),
            x1: "2",
            y1: "50%",
            x2: e.strokeWidth,
            y2: "50%",
            "stroke-dasharray": e.strokeDasharray,
            "stroke-dashoffset": e.strokeDashoffset
          }, null, 10, ae)
        ])
      ])),
      e.isShowingFooter ? (n(), l("div", {
        key: 1,
        class: o(e.footerStyles)
      }, [
        c(e.$slots, "footer", { value: e.localValue })
      ], 2)) : y("", !0)
    ], 64)) : e.isCircleType ? (n(), l("svg", {
      key: 1,
      viewBox: "0 0 16 16",
      width: e.computedSize,
      height: e.computedSize
    }, [
      t("g", le, [
        t("circle", {
          class: o(e.progressBarBackgroundStyles),
          cx: "50%",
          cy: "50%",
          r: "7"
        }, null, 2),
        t("circle", {
          class: o(e.progressBarMainPartStyles),
          cx: "50%",
          cy: "50%",
          r: "7",
          "stroke-dasharray": e.strokeDasharray,
          "stroke-dashoffset": e.strokeDashoffset
        }, null, 10, ie)
      ])
    ], 8, ne)) : y("", !0)
  ], 2);
}
const he = /* @__PURE__ */ I(re, [["render", ce]]);
export {
  he as O,
  s as P,
  a
};
//# sourceMappingURL=OrProgress-cgGfaP0m.mjs.map
